import { putToS3 } from '@components/Files/UploadProvider/helpers/putToS3';
import type { TUploaderAdapter } from '@components/Files/UploadProvider/types/TUploadParams';
import { fetchUploadParams } from './fetchUploadParams';
import type { TGenerateUploadParams } from './types/TGenerateUploadParams';

export const RepositoryS3Uploader = (
  generateUploadParams: TGenerateUploadParams,
  getRepositoryId: () => string,
): TUploaderAdapter => ({
  requestParams: async ({ file, meta }) => {
    if (!(file instanceof File)) {
      throw new Error('Only File supported');
    }
    const repositoryId = getRepositoryId();
    if (!repositoryId) {
      throw new Error('Wrong repository ID');
    }
    return fetchUploadParams(meta.name, repositoryId, generateUploadParams);
  },
  performUpload: async ({ file, params, onProgress, signal }) => {
    if (!(file instanceof File)) {
      throw new Error('Only File supported');
    }
    return putToS3({ file, params, onProgress, signal });
  },
});
